<template>
    <div class="wrapper">
        <!-- Contact Us 1 -->
        <div
                class="section section-contactus-1 section-image"
                :style="sectionContactUs(contactus1)"
        >
            <div class="container">
                <div class="md-layout">
                    <div class="md-layout-item md-size-40 md-small-size-100">
                        <h2 class="title">
                            Готовы подключится?
                        </h2>
                        <h5 class="description">
                            Просто оставьте заявку или позвоните нам.
                            Подключение бесплатно и не занимает более 30 минут! Наши специалисты подключатся и все настроят.
                            <br>
                            <br>
                            Так же вы можете возможно интегрировать своими силами.
                        </h5>
                        <info-areas
                                info-horizontal
                                icon-color="primary"
                                icon="pin_drop"
                        >
                            <h4
                                    slot="title"
                                    class="info-title"
                            >
                                Позвоните нам
                            </h4>
                            <div
                                    slot="content"
                                    class="description"
                            >
                                <p>
                                    Бесплатно из РФ: <br>
                                    <a href="tel:8-800-222-02-50">8-800-222-02-50</a>
                                    <br>
                                    support@akitorg.ru
                                    <br>
                                    Пн - Пт, 9:00-21:00
                                </p>
                            </div>
                        </info-areas>
                    </div>

                    <div class="md-layout-item md-size-40 md-small-size-100 ml-auto" v-if="!sended">
                        <md-card class="md-card-contact">
                            <md-card-header class="md-card-header-primary text-center">
                                <h4 class="card-title">
                                    Заявка на подключение
                                </h4>
                            </md-card-header>
                            <md-card-content>
                                <md-field>
                                    <label>Имя</label>
                                    <md-input
                                            v-model="name"
                                            type="text"
                                    />
                                </md-field>
                                <md-field>
                                    <label>Телефон</label>
                                    <md-input
                                            v-model="phone"
                                            type="text"
                                    />
                                    <span v-if="errors.phone" class="span_error" style="color: red;">{{errors.phone}}</span>
                                </md-field>
                                <md-field>
                                    <label>Email</label>
                                    <md-input
                                            v-model="email"
                                            type="email"
                                    />
                                    <span class="span_error"  style="color: red;">{{errors.email}}</span>
                                </md-field>
                            </md-card-content>
                            <md-card-actions class="d-flex justify-content-between">
                                <div class="md-layout">
                                    <div class="md-layout-item md-size-100 md-small-size-100 ml-auto" >
                                        <md-checkbox v-model="checkPerson" id="chB">
                                            <label for="chB" v-bind:style="{color: color}">я согласен на обработку персональных данных</label>
                                        </md-checkbox>
                                    </div>
                                    <div class="md-layout-item md-size-100 md-small-size-100 ml-auto">
                                    </div>
                                    <div class="md-layout-item md-size-100 md-small-size-100 text-right ">
                                        <vue-recaptcha
                                                :sitekey="key"
                                                ref="recaptcha"
                                                size="invisible"
                                                @verify="register"
                                                @expired="onCaptchaExpired"
                                        />
                                        <md-button class="md-success" style="background: #304ffe;" v-on:click="validate">
                                            Отправить
                                        </md-button>
                                    </div>
                                </div>
                            </md-card-actions>
                        </md-card>
                    </div>
                    <div class="md-layout-item md-size-40 md-small-size-100 ml-auto" v-else>
                        <md-card class="md-card-contact">
                            <md-card-header class="md-card-header-primary text-center">
                                <h4 class="card-title"> Заявка на подключение.</h4>
                            </md-card-header>
                            <md-card-content class="text-center" style="height: 300px;">
                                <md-field>
                                    <h3>Заявка отправлена. <br> С вами свяжется наш специалист.</h3>
                                    <br>
                                </md-field>
                            </md-card-content>
                            <md-card-actions class="d-flex justify-content-between">
                                <div class="md-layout">
                                    <div class="md-layout-item md-size-100 md-small-size-100 text-right">
                                    </div>
                                </div>
                            </md-card-actions>
                        </md-card>
                    </div>
                </div>
            </div>
            <a name="support"></a>
        </div>
    </div>
</template>

<script>
  import { InfoAreas } from "@/components";
  // import Mixins from "@/plugins/basicMixins";
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: "BlockContact",
    components: { VueRecaptcha, InfoAreas },
    data() {
      return {
        key: "6Leeqz8aAAAAAPj40JaEBOKQmpYdUvNFcBJ0LS25",
        name: "",
        phone: "",
        email: "",
        checkPerson: false,
        sended: false,
        errors: {email:'', phone:''},
        color: "#aaa",
        isDisabled: true,
        contactus1: require("@/assets/img/1920_akitorg_main-min.jpg")
      };
    },
    watch: {
      checkPerson: function () {
        if(this.validConfirm()){
          this.color = '#aaa'
        }
      },
      phone: function () {
        if(this.validePhone(this.phone)){
          this.errors.phone = ''
        }
      },
    },
    methods: {
      checkForm () {
        if (!this.validEmail(this.email)){
          this.errors.email = 'Не похоже на email';
          this.validePhone(this.phone)
          this.validConfirm()
          return false
        }
        if (!this.validePhone(this.phone)){
          this.errors.phone = 'Не похоже на телефон';
          this.validConfirm()
          return false
        }
        if (!this.validConfirm()){
          return false
        }
        return true
      },
      register (recaptchaToken) {
        const axios = require('axios');
        axios({
          method: 'post',
          url: 'https://akitorg.ru/register.php',
          data: {
            name: this.name,
            email: this.email,
            phone: this.phone,
            accept: this.checkPerson,
            recaptchaToken: recaptchaToken
          }
        })
          .then((res) => {
            if (res.status === 200) {
              this.sended = true;
              if (res.data > 0) {
                // переход
                alert(res.data)
              }
            }
          })
          .catch((error) => {
            alert(error)
          })


      },
      validate () {
        if (this.checkForm()){
          this.$refs.recaptcha.execute()
        }

      },
      onCaptchaExpired () {
        this.$refs.recaptcha.reset()
      },
      validEmail: function (email) {
        if (email.length == 0 ){
          return true
        }
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      validePhone: function (phone) {
        var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
        return re.test(phone);
      },
      validConfirm (){
        if (!this.checkPerson){
          this.color = 'red';
          return false
        } else {
          return true
        }
      },
      sectionContactUs(image) {
        return {
          backgroundImage: `url(${image})`
        };
      }
    },
  }
</script>

<style lang="scss">
    .justify-content-between {
        justify-content: space-between !important;
    }
</style>
